import {
  BatchRecordFillingBatch,
  CreateBatchRecordFillingBatchRequest
} from '../types/batchRecordFillingBatch';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export const batchRecordFillingBatchApiService = {
  /**
   * Fetch all batch record filling batches from the backend
   */
  fetchAllBatchRecordFillingBatches: async (): Promise<BatchRecordFillingBatch[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-record-filling-batches`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch batch record filling batches');
      }

      return data.batchRecordFillingBatches;
    } catch (error) {
      console.error('Error fetching batch record filling batches from API:', error);
      throw error;
    }
  },

  /**
   * Fetch batch record filling batches by batch record ID
   */
  fetchBatchRecordFillingBatchesByBatchRecordId: async (batchRecordId: string): Promise<BatchRecordFillingBatch[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-record-filling-batches/by-batch-record/${batchRecordId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch batch record filling batches');
      }

      return data.batchRecordFillingBatches;
    } catch (error) {
      console.error('Error fetching batch record filling batches by batch record ID from API:', error);
      throw error;
    }
  },

  /**
   * Create a new batch record filling batch
   */
  createBatchRecordFillingBatch: async (data: CreateBatchRecordFillingBatchRequest): Promise<BatchRecordFillingBatch> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-record-filling-batches`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();

      if (!responseData.success) {
        throw new Error(responseData.error || 'Failed to create batch record filling batch');
      }

      return responseData.batchRecordFillingBatch;
    } catch (error) {
      console.error('Error creating batch record filling batch:', error);
      throw error;
    }
  },

  /**
   * Delete a batch record filling batch by ID
   */
  deleteBatchRecordFillingBatch: async (id: string): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-record-filling-batches/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete batch record filling batch');
      }
    } catch (error) {
      console.error('Error deleting batch record filling batch:', error);
      throw error;
    }
  }
};
